import { MipsEligibilityDto } from '@models/mips-eligibility-response';
import { MipsEligibilityInfo, MipsEligibilityResponse } from '@models/mips-stepper.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MipsEligibilityActions = createActionGroup({
  source: 'MipsEligibility',
  events: {
    'Check Eligibility': props<{
      npi: string;
      performanceYear: number;
      practice: string;
      tin: string;
    }>(),
    'Check Eligibility Success': props<{ 
      result: MipsEligibilityResponse;
    }>(),
    
    'Check Eligibility Failure': props<{ error: string }>(),

    'Select Organization': props<{ organization: MipsEligibilityDto }>(),

    'Clear Eligibility Results': emptyProps(),

    'Check Batch Eligibility': props<{ 
      npis: string[]; 
      performanceYear: number 
    }>(),
    
    'Check Batch Eligibility Success': props<{ 
      results: MipsEligibilityResponse[] 
    }>(),
    
    'Check Batch Eligibility Failure': props<{ error: string }>(),
  }
});